import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useContentAttach } from '../../hooks'
import { MonolithicEditor } from '../MonolithicEditor'
import { SymbolEditor } from '../SymbolEditor'

interface Props {
  blockId: ID
  readOnly: boolean
}

export const BlockEditor: React.FC<Props> = ({ blockId, readOnly }) => {
  const block = useSelector(
    migrationProjectSelector.getProjectBlockUnsafe(blockId)
  )

  const { onUpload } = useContentAttach()

  if (block.type === 'monolithic') {
    return (
      <MonolithicEditor readonly={readOnly} onUpload={onUpload} id={blockId} />
    )
  }

  if (block.type === 'symbol') {
    return (
      <SymbolEditor
        readonly={readOnly}
        onUpload={onUpload}
        id={block.symbolId}
      />
    )
  }

  return null
}
